import React, { useState } from 'react'
import { message, Form, Input, Modal, Row, Col, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  loadParkedSaleModalvisible,
  loadSaleOrderJson,
  loadFormSellNote
} from '../../appRedux/actions/MainSale'
import { isEmptyObject, parkSale } from '../../appRedux/actions/GlobalMethods'
import { manageIndexedCartJson } from '../../appRedux/actions/saleIndexDB'
import { GetIndexDBDataByTableName } from '../../appRedux/actions/IndexDBActions'
import { INDEX_DB_NAME, INDEX_DB_TABLES } from '../../constants/IndexDBData'

const ParkedSaleModal = props => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getParkedSaleModalVisible = useSelector(
    ({ MainSale }) => MainSale.getParkedSaleModalVisible
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const sellActionLog = useSelector(({ Sell }) => Sell.sellActionLog)
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (getCurrentSalesOrderData && getCurrentSalesOrderData.Notes == '') {
        const qqq = formSellNote
        form.resetFields()
      }
      if (formSellNote) {
        form.setFieldsValue({ SellNotes: formSellNote })
      }
    }

    return () => (mounted = false)
  }, [getParkedSaleModalVisible])

  const handleClickParkedSale = () => {
    if (isOnline && getSaleOrderJson.indexKey) {
      const checkParked = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.SALES
      )
      checkParked
        .then(async e => {
          const saleExist = e.filter(
            q =>
              q.indexKey == getSaleOrderJson.indexKey &&
              q.isOffline &&
              q.isParked
          )
          if (saleExist && saleExist.length > 0) {
            parkSaleFn(false)
          }
          else parkSaleFn(isOnline)
        })
        .catch(e => {
          parkSaleFn(isOnline)
          // console.log('INDEX_DB_ERROR -> forceUpdateIndexSales -->', e)
        })
    } else {
      parkSaleFn(isOnline)
    }
  }

  function parkSaleFn (pretendOnline) {
    parkSale(
      getSaleOrderJson,
      getSalesOrderStatuses,
      getCurrentSalesOrderData,
      {},
      getIsRefundSale,
      dispatch,
      getReduxSalePaymentData,
      sellSelAttributes,
      !getIsSalePaymentProcessStart ? sellActionLog : [],
      getDeletedProds ? getDeletedProds : [],
      pretendOnline
    )
  }

  function setSellNotesOnJson () {
    let saleOrderJson = getSaleOrderJson
    saleOrderJson.Notes = form.getFieldValue('SellNotes')
    // setSaleOrderJson(saleOrderJson);
    dispatch(loadSaleOrderJson(saleOrderJson))
    manageIndexedCartJson(
      saleOrderJson,
      true,
      false,
      false,
      'setSellNotesOnJson --> ParkedSaleModal'
    )
  }

  const handleChangeSellNotes = e => {
    dispatch(loadFormSellNote(e.target.value))
    setSellNotesOnJson()
  }

  return (
    <Modal
      title={
        
        <strong>  <IntlMessages id='sell.sell.addanotetothesale' /></strong>
        
      }
      visible={getParkedSaleModalVisible}
      okText={<IntlMessages id='common.resource.save' />}
      // confirmLoading={confirmLoading}
      onCancel={() => {
        dispatch(loadParkedSaleModalvisible(false))
      }}
      width={400}
      centered={true}
      footer={[
        <Button
          type='primary'
          // loading={confirmLoading}
          onClick={() => {
            handleClickParkedSale()
          }}
          className='dk-btn-add'
        >
          <IntlMessages id='sell.sell.parksale' />
        </Button>
      ]}
    >
      <Row>
        <Col md={24}>
          <p className=''>
            <IntlMessages id='sell.sell.youareabouttopark' />
          </p>
        </Col>
      </Row>
      <Form form={form} layout='vertical' name='SellForm'>
        <Row>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Col span={24} className='custom-pd-left-right'>
              <Form.Item className='' name='SellNotes'>
                <Input.TextArea
                  value={formSellNote}
                  defaultValue={formSellNote}
                  onChange={e => handleChangeSellNotes(e)}
                  className='product-notes-hg'
                  placeholder='Enter a note about this sale'
                  showCount
                  maxLength={1500}
                />
              </Form.Item>
            </Col>
          </div>

          <p className='dk-text--sub dk-text--secondary mt-3 mb-0'>
            <IntlMessages id='sell.sell.notescanbeused' />
          </p>
        </Row>
      </Form>
    </Modal>
  )
}

export default ParkedSaleModal
